import * as R from "ramda";
import { fromObject } from "../../utils";
import lens from "../lenses/refunds";

export default {
  root: R.view(lens),
  ids: R.view(lens.ids),
  data: R.view(lens.data),
  total: R.view(lens.total),
  isLoading: R.view(lens.isLoading),
  pagination: R.view(lens.pagination),
  error: R.view(lens.error),
  userNameQuery: R.view(lens.userNameQuery),
  orderNumberQuery: R.view(lens.orderNumberQuery),
  inOrder: state => {
    if (!state) {
      throw new Error("must provide state!");
    }

    const ids = R.defaultTo([], R.view(lens.ids, state));
    const data = R.view(lens.data, state);

    return ids.map(fromObject(data));
  },
  tableView: state => {
    const ids = R.defaultTo([], R.view(lens.ids, state));
    const data = R.view(lens.data, state);

    return ids.map(id => data[id]);
  }
};
